
const pollerLite = (conditions, callback, maxTime = 100000) => {
  const POLLING_INTERVAL = 25;
  const startTime = Date.now();
  const interval = setInterval(() => {
    const allConditionsMet = conditions.every((condition) => {
      if (typeof condition === 'function') {
        return condition();
      }
      return !!document.querySelector(condition);
    });
    if (allConditionsMet) {
      clearInterval(interval);
      callback();
    } else if (Date.now() - startTime >= maxTime) {
      clearInterval(interval);
      console.error('Polling exceeded maximum time limit');
    }
  }, POLLING_INTERVAL);
};

const captureElementsContainingString = (searchString = "_pfand") => {
  const elements = [...document.querySelectorAll('.upcart-item-property')]; //Get all elements as an array

  return elements.filter((el) => el.textContent.includes(searchString));
};

const pfMainProductInputDisable = () => {
    pollerLite([()=> document.querySelectorAll('.upcart-item-property') && document.querySelectorAll('.upcart-item-property').length > 0], ()=>{
        const isFindMainProducts = captureElementsContainingString();
        console.log(isFindMainProducts, 'isFindMainProducts');
        if(isFindMainProducts && isFindMainProducts.length > 0){
            isFindMainProducts.forEach(mainProduct=> {
                const mainWrapper = mainProduct.closest('.styles_ProductRow__product__.upcart-product-item');
                if(mainWrapper) mainWrapper.classList.add('disable-input-for-pf');
            });
        }
    });
    
}

const pfandAtcFn = (secondProductVariantId) => {
    window.addEventListener('aftersell-upcart:public-events:added-to-cart', function (event) {
        window.__suppressPfandSync = true;
        const quantity = document.getElementById('pfand-quantity').value;
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                items: [
                    {
                        id: secondProductVariantId,
                        quantity: quantity,
                    },
                ],
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                setTimeout(() => {
                    window.__suppressPfandSync = false;
                }, 2000);
            })
            .catch((error) => {
                console.error('Error adding second product:', error);
            });
    });
};

const pfandUpdateFn = (secondProductVariantId) => {
    window.addEventListener('aftersell-upcart:public-events:cart-updated', function (event) {
        if (window.__suppressPfandSync) {
            return;
        }
        const cartItems = event.detail.cart.items;
        const pfandItems = cartItems.filter((item) => item.properties && item.properties._pfand);
        let desiredQty = 0;

        pfandItems.forEach((item) => {
            const pfandQuantity = item.properties._pfand_quantity ? parseInt(item.properties._pfand_quantity) : 0;
            desiredQty += item.quantity * pfandQuantity;
        });

        const secondProduct = cartItems.find((item) => item.variantId == secondProductVariantId);
        const currentQty = secondProduct ? secondProduct.quantity : 0;

        if (currentQty == desiredQty) return;

        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                updates: {
                    [secondProductVariantId]: desiredQty,
                },
            }),
        })
            .then((res) => res.json())
            .then((data) => {
                window.upcartRefreshCart();
            })
            .catch((err) => {
                window.upcartRefreshCart();
                console.error('Error syncing second product quantity:', err);
            });
    });
};

const pfandPropertiesUpdateFn = () => {
    document.querySelector('.product-section .product-single__meta').addEventListener('change', () => {
        const currentVariantId = document.querySelector('.product-single__variants').value;
        const matchedPfand = pfandVariants.find((v) => v.id == currentVariantId);
        if (matchedPfand) {
            pfandInputQuantity.value = matchedPfand.pfand_quantity;
        }
    });
};

let pfandInput = document.getElementById('pfand-property');
let pfandInputQuantity = document.getElementById('pfand-quantity');
if (pfandInput && pfandInputQuantity) {
    pfandAtcFn(pfandInput.value);
    pfandUpdateFn(pfandInput.value);
    pfandPropertiesUpdateFn();
};

window.addEventListener('aftersell-upcart:public-events:cart-opened', () => {
    pfMainProductInputDisable();
});

window.addEventListener('aftersell-upcart:public-events:cart-updated', function (event) {
    pfMainProductInputDisable();
});
